import { useEffect } from 'react';
import { boardKindsForTab, declareBoardKinds } from '../stores/boardKinds';

/** Declare which board tab this view has open (feed gateway `board` facet).
 *  Split effects, like useFeedNeeds: a tab change re-declares over the top and
 *  only unmount clears — never a transient "no declaration" (= every kind). */
export function useBoardKinds(sourceId: string, tab: string): void {
  useEffect(() => {
    declareBoardKinds(sourceId, boardKindsForTab(tab));
  }, [sourceId, tab]);
  useEffect(() => () => declareBoardKinds(sourceId, null), [sourceId]);
}
